@if ({ link: navLinks(), deviceType: deviceType$ | async }; as headerNavData) { @if (headerNavData.deviceType ===
'desktop') {
<!-- Desktop View -->
<custom-dot-cms-uve-desktop-view-header-navigation [navLinks]="headerNavData.link" />
} @else {
<custom-dot-cms-uve-general-view-header-navigation [navLinks]="headerNavData.link" />
}
<!-- Mobile and Tablet View -->
}
